<template>
  <div
    :class="{ 'toggle-active': isActive }"
    @click="toggle()"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Toggle',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isActive: false
    }
  },

  created () {
    this.updateStore()
  },

  methods: {
    toggle () {
      this.isActive = !this.isActive
      this.updateStore()
    },

    updateStore () {
      this.$store.dispatch('toggle/updateToggleState', { id: this.id, isActive: this.isActive })
    }
  }
}
</script>